export default {
  data() {
    return {
      maxFrames: 100,
    };
  },

  methods: {

    getRaceConfig( configName , cached = false) {
      if (!!this.$root.raceConfig && !!this.$root.raceConfig[configName]  ) {
        console.log("PRENDO "+configName+" da CONFIG>>>" + (cached ? ' from cache ': ''))
        console.log(this.$root.raceConfig[configName])
        return this.$root.raceConfig[configName];
       } else {
        return [];
       }
    },

    isConfigChanged( configName, oldValue ) {
        const newVal= JSON.stringify(this.getRaceConfig(configName))
        const oldVal = JSON.stringify(oldValue);
        const res = newVal != oldVal;
        if (res) console.log("isConfigChanged "+configName)
        return res;
    },

    setRaceConfig(rConf) {
      console.log("Scrivo in race config ")
      console.log(rConf)
      this.raceConfig = rConf;
    },

    getDataURL() {
      if (process.env.NODE_ENV == 'production')
        return process.env.VUE_APP_DATA_URL;

      return process.env.VUE_APP_DATA_URL_LOCAL;
    },

    getTagsURL() {
      if (process.env.NODE_ENV == 'production')
        return process.env.VUE_APP_TAGS_URL;

      return process.env.VUE_APP_TAGS_URL_LOCAL;
    },

    


    getApiURL() {
      // console.log("Get URL:" + window.location.href);
      if (process.env.NODE_ENV == 'production')
        return process.env.VUE_APP_API_URL;

      return process.env.VUE_APP_API_URL_LOCAL;
    },


    getApi2URL() {
      return "http://localhost:8085/";
    },

    getHomeURL() {
      // console.log("Get URL:" + window.location.href);
      if (process.env.NODE_ENV == 'production')
        return process.env.VUE_HOME_URL;

      return process.env.VUE_HOME_URL_LOCAL;
    },


    getReportURL() {
      console.log(process.env.VUE_APP_REPORT_URL);
      if (process.env.NODE_ENV == 'production')
        return process.env.VUE_APP_REPORT_URL;

      return process.env.VUE_APP_REPORT_URL;
    },


    getMappaUrl() {

      if (process.env.NODE_ENV == 'production')
        return process.env.ICRON_VIRTUALDRONE_URL;

      return process.env.ICRON_VIRTUALDRONE_URL;

    },

    restCall(url) {
      const myHeaders = new Headers();
      //myHeaders.append('icron_token', global.helper.ls.get("IcronZero-Token"));
      // if (global.helper.ls.get("IcronZero-UserId") !== undefined) myHeaders.append('icron_user', global.helper.ls.get("IcronZero-UserId").toLowerCase());
      // myHeaders.append('icron_timer', global.helper.ls.get("IcronZero-Timer"));
      //myHeaders.append('icron_racefolder', global.helper.ls.get("IcronZero-RaceFolder"));
      //this.controlLoadingSpinner(true);
      //myHeaders.append('Access-Control-Allow-Origin', '*')
      return fetch(this.getApiURL() + url, {
        headers: myHeaders
      }).then((response) => {
        // this.controlLoadingSpinner(false);
        return response;
      })
    },


    restPost(_url, _json) {
    
      return fetch(this.getApi2URL() + _url, {
       // headers: {'Content-Type:': 'application/json'},
        method: 'post',
        body: JSON.stringify(_json),
        headers: {
          "Content-Type": "application/json",
        },
      }).then((response) => {
        console.log(response)
        if (response.status == 200)
        // this.controlLoadingSpinner(false);
          return (response.json())
        else 
          return response
      })
    },

    restPut(_url, _json) {
    
      return fetch(this.getApi2URL() + _url, {
       // headers: {'Content-Type:': 'application/json'},
        method: 'post',
        body: JSON.stringify(_json),
        headers: {
          "Content-Type": "application/json",
        },
      }).then((response) => {
        console.log(response)
        if (response.status == 200)
        // this.controlLoadingSpinner(false);
          return (response.json())
        else 
          return response
      })
    },
    


    deleteCall(_url) {
    
      return fetch(this.getApi2URL() + _url, {
       // headers: {'Content-Type:': 'application/json'},
        method: 'delete',
      }).then((response) => {
        console.log(response)
        return response
          
      })
    },


    getEventoIcron(idGara, divisione) {
      let _url = 'getIscrizioni';
      let _json = {};
      _json.idGara = idGara;
      if (divisione && divisione !== 'none')
        _json.divisione = divisione;
      return fetch(this.getApiURL() + _url, {
        method: 'post',
        body: JSON.stringify(_json)
      }).then((response) => {
        // this.controlLoadingSpinner(false);
        return (response.json())
      })
    },


    getEventoBaseIcron(idGara) {
      let _url = 'getIscrizioniBase';
      let _json = {
        "datiIscrizione": [
            {
                "idGara":idGara
            }
        ]
      }

      return fetch(this.getApiURL() + _url, {
        method: 'post',
        body: JSON.stringify(_json)
      }).then((response) => {
        // this.controlLoadingSpinner(false);
        return (response.json())
      })
    },

    getClassificaIcron(idGara, divisione) {
      let _url = 'getClassifica';
      let _json = {};
      _json.idGara = idGara;
      if (divisione && divisione !== 'none')
        _json.divisione = divisione;
      return fetch(this.getApiURL() + _url, {
        method: 'post',
        body: JSON.stringify(_json)
      }).then((response) => {
        // this.controlLoadingSpinner(false);
        return (response.json())
      })
    },


    getDiploma(inputCriteria) {
      let _url = 'getDiploma';
      let _json = inputCriteria;
      return fetch(this.getApiURL() + _url, {
        method: 'post',
        body: JSON.stringify(_json)
      }).then((response) => {
        // this.controlLoadingSpinner(false);
        return (response.json())
      })
    },

    getDettaglioEventoARI(_url, idIscrizione) {
      let _json = {};

      if (idIscrizione != undefined) {
        _json["idx"] = idIscrizione 
      }
       
      return fetch(this.getApiURL() + _url, {
        method: 'post',
        body: JSON.stringify(_json)
      }).then((response) => {
        // this.controlLoadingSpinner(false);
        return (response.json())
      })
    },

    getEventoARI(_url) {
      let _json = {};
      return fetch(this.getApiURL() + _url, {
        method: 'post',
        body: JSON.stringify(_json)
      }).then((response) => {
        // this.controlLoadingSpinner(false);
        return (response.json())
      })
    },


    getAggiornamentoDatiARI(_url) {
      let _json = {};

      return fetch(this.getApiURL() + _url, {
        method: 'post',
        body: JSON.stringify(_json)
      }).then((response) => {
        // this.controlLoadingSpinner(false);
        return (response.json())
      })
    },

    invioWAServer(_url, _json) {
      return fetch(this.getApiURL() + _url, {
        method: 'post',
        body: JSON.stringify(_json)
      }).then((response) => {
        // this.controlLoadingSpinner(false);
        return (response.json())
      })
    },


    salvaRilevamentoARI(_url, _json) {
      return fetch(this.getApiURL() + _url, {
        method: 'post',
        body: JSON.stringify(_json)
      }).then((response) => {
        // this.controlLoadingSpinner(false);
        return (response.json())
      })
    },


    registraRitiroARI(_url, _json) {
      return fetch(this.getApiURL() + _url, {
        method: 'post',
        body: JSON.stringify(_json)
      }).then((response) => {
        // this.controlLoadingSpinner(false);
        return (response.json())
      })
    },


    getEventiGara(_json) {
      const _url = "https://www.icron.it/IcronLiveServices/services/elencoEventiGara";

      return fetch( _url, {
        method: 'post',
        body: JSON.stringify(_json)
      }).then((response) => {
        // this.controlLoadingSpinner(false);
        return (response.json())
      })
    },

    creaEventoGara(_json) {
      const _url = "https://www.icron.it/IcronLiveServices/services/creaEventoGara";

      return fetch( _url, {
        method: 'post',
        body: JSON.stringify(_json)
      }).then((response) => {
        // this.controlLoadingSpinner(false);
        return (response.json())
      })
    },

    aggiornaEventoGara(_json) {
      const _url = "https://www.icron.it/IcronLiveServices/services/aggiornaEventoGara";

      return fetch( _url, {
        method: 'post',
        body: JSON.stringify(_json)
      }).then((response) => {
        // this.controlLoadingSpinner(false);
        return (response.json())
      })
    },


    eliminaEventoGara(_json) {
      const _url = "https://www.icron.it/IcronLiveServices/services/eliminaEventoGara";

      return fetch( _url, {
        method: 'post',
        body: JSON.stringify(_json)
      }).then((response) => {
        // this.controlLoadingSpinner(false);
        return (response.json())
      })
    },

    getClassifica(jsonFile) {
      const myHeaders = new Headers();
      const _url = this.getReportURL() + jsonFile;
      //console.log(_url)
      return fetch(_url, {
        headers: myHeaders
      }).then((response) => {
        // this.controlLoadingSpinner(false);
        //console.log(response)
        return (response.json())
      })
    },
    
    getElencoGareLive(startFrom, endTO){
      let _url = 'getGareLive';
      let _json = {dataInf: startFrom, dataSup: endTO};
      
      return fetch(this.getApiURL() + _url, {
        method: 'post',
        body: JSON.stringify(_json)
      }).then((response) => {
        // this.controlLoadingSpinner(false);
        return (response.json())
      })
    },

    checkVersion(inout) {
      let _url = 'getVersion?appName=LIVE';
      return fetch(this.getApiURL() + _url, {
      }).then((response) => {
        return (response.json())
      })
    },

    getClassificaRR(idGara, token) {
      const myHeaders = new Headers();
      const _url = "https://api.raceresult.com/" + idGara + "/" + token;
      //console.log(_url)
      return fetch(_url, {
        headers: myHeaders
      }).then((response) => {
        // this.controlLoadingSpinner(false);
        //console.log(response)
        return (response.json())
      })
    },


    getAttivitaGpsEvento(idGara, criterio) {
      let _url = '/gps/getProfiliAttivitaGps';
      let _json = { idGara: idGara }
      if (criterio !== undefined) {
        _json[criterio] = ""
      }
      return fetch(this.getApiURL() + _url, {
        method: 'post',
        body: JSON.stringify(_json)
        //body: "{}"
      }).then((response) => {
        // this.controlLoadingSpinner(false);
        return (response.json())
      })
    },

    getPosizioniDevices(deviceList, numRilevamenti = 1) {
      let _url = '/traccar/getPosizioniDevices';
      let _json = { "traccar": {
          "numRilevamenti": numRilevamenti,
         // "dataEvento": dataEvento,
          "devicesId": deviceList
      } }
     
      return fetch(this.getApiURL() + _url, {
        method: 'post',
        body: JSON.stringify(_json)
        //body: "{}"
      }).then((response) => {
        // this.controlLoadingSpinner(false);
        return (response.json())
      })
    },

    aggiornaPosizioniDevices(id, value) {
      let _url = '/traccar/aggiornaPosizioniDevices';
      let _json = {
        "elencoTraccar": [
              {
                  "id":id,
                  "alarm":value
              }
          ]
      }
     
      return fetch(this.getApiURL() + _url, {
        method: 'post',
        body: JSON.stringify(_json)
        //body: "{}"
      }).then((response) => {
        // this.controlLoadingSpinner(false);
        return (response.json())
      })
    },


    getSlotPrenotazioneEvento(idGara, data) {
      let _url = '/liquid/getOccupazioneSlot';
      let _json = { idGara: idGara }
      _json['data'] = data;
      return fetch(this.getApiURL() + _url, {
        method: 'post',
        body: JSON.stringify(_json)
        //body: "{}"
      }).then((response) => {
        // this.controlLoadingSpinner(false);
        return (response.json())
      })
    },

    getGaraRandom(idGaraAri, token) {
      let _url = 'ari/getGaraAri/' + idGaraAri + '/' + token;
      return fetch(this.getApiURL() + _url, {
        method: 'post',
        body: JSON.stringify({ criterio: 'PART' })
        //body: "{}"
      }).then((response) => {
        // this.controlLoadingSpinner(false);
        return (response.json())
      })
    },


    getPassaggiRandom(idGaraAri, token) {
      let _url = 'ari/elencoBrevetti/' + idGaraAri + '/' + token;
      return fetch(this.getApiURL() + _url, {
        method: 'post',
        body: JSON.stringify({ criterio: 'PART' })
        //body: "{}"
      }).then((response) => {
        // this.controlLoadingSpinner(false);
        return (response.json())
      })
    },

    getAttivita(idAttivita, token) {
      let _url = 'gps/getAttivitaGps?idAttivita=' +
        idAttivita +
        '&token=' + token
      return this.restCall(_url)
        .then(result => {
          return (result.json())
        })
    },


    getRemoteService(_url) {
      return fetch(_url).then((response) => {
        // this.controlLoadingSpinner(false);
        //console.log(response)
        return (response.text())
      })
    },

    getCall(_url) {
      return fetch(_url).then((response) => {
        // this.controlLoadingSpinner(false);
        //console.log(response)
        return (response.json())
      })
    },

    writeTag(_url) {
      return fetch(_url).then((response) => {
        // this.controlLoadingSpinner(false);
        //console.log(response)
        return (response.text())
      })
    },


    printForm(_url, rows) {
      return fetch( _url, {
        method: 'post',
        body: JSON.stringify( { rows: rows, title: 'aaa' })
      }).then((response) => {
        // this.controlLoadingSpinner(false);
        return (response.json())
      })
    },




    getConfiguration(idEvento) {
      let _url = 'events/' +
        idEvento +
        '/configuration.csv?d=' +
        new Date()
      return this.restCall(_url)
        .then(result => {
          return (result.text())
        })
    },

    getElencoDevices(idEvento) {
      let _url = 'events/' +
        idEvento +
        '/staff.csv?d=' +
        new Date()
      return this.restCall(_url)
        .then(result => {
          return (result.text())
        })
    },

    getElencoDevicesPartecipanti(idEvento) {
      let _url = 'events/' +
        idEvento +
        '/partecipanti.csv?d=' +
        new Date()
      return this.restCall(_url)
        .then(result => {
          return (result.text())
        })
    },

    getPercorso(idEvento, idPercorso, type) {
      if (type == undefined) type = "json";
      var suffix = "." + type;
      let _url = 'events/' +
        idEvento +
        '/' + idPercorso + suffix + '?d=' +
        new Date()
      console.log(_url)
      return this.restCall(_url)
        .then(result => {
          return (result.text())
        })
    },

    getAltimetria(idEvento, idPercorso) {
      var suffix = ".txt";
      let _url = 'events/' +
        idEvento +
        '/' + idPercorso + suffix + '?d=' +
        new Date()
      console.log(_url)
      return this.restCall(_url)
        .then(result => {
          return (result.text())
        })
    },


    csvJSON(csv, startFrom = 0, separator = ";") {
      let _csv = csv.replaceAll("\t", separator)
      var lines = _csv.toUpperCase().split("\n");
      var result = [];
      var headers = lines[0].split(separator);
      for (var i = 0; i < headers.length; i++) {
        if (headers[i] != undefined)
          headers[i] = headers[i].replace(/[\s]+[,]+|[,]+[\s]+/g, ',').trim().toLowerCase();
      }
      for (var i = (startFrom +1 ); i < lines.length; i++) {
        const line = this.normalize(lines[i]).toUpperCase();
        if (line.length == 0) continue;

        var obj = {};
        var currentline = lines[i].split(separator);

        for (var j = 0; j < headers.length; j++) {
          obj[headers[j]] = this.normalize(currentline[j]);
        }

        result.push(obj);

      }
      return result; //JSON
    },


   normalize(str){
      if (str !== undefined) {
        return str.replaceAll("\r","").replaceAll("\"","");
      }
   },

   normalizeNaz(naz){
    if (naz !== undefined) {
      naz = naz.toUpperCase();
       if (naz === 'GER') naz = 'DEU';
       else if (naz === 'NED') naz = 'NLD';
       else if (naz === 'DEN') naz = 'DNK';
       else if (naz === 'GRE') naz = 'GRC';
       else if (naz === 'LAT') naz = 'LVA';
       else if (naz === 'POR') naz = 'PRT';
       else if (naz === 'SUI') naz = 'CHE';
      }
      return naz;
    },

    properties2Object(csv) {
      var result = {};
      var lines = csv.split("\n");
      for (var i = 0; i < lines.length; i++) {
        if (lines[i].startsWith("//") ) continue;
        var currentline = lines[i].split("=");
        if (currentline.length > 1) result[currentline[0]] = this.normalize(lines[i].substring(currentline[0].length+1,lines[i].length ));
        else if (currentline.length == 1  && lines[i].startsWith("show") ) result[currentline[0]] = "true";
        else if (currentline.length == 1  && lines[i].startsWith("#show") ) result[lines[i].substring(1,lines[i].length)] = "false";
      }
      return result; //JSON
    },



    interpola(coordinates, indexGPS, currentFrame, maxFrames = 100) {
      if (indexGPS > 1) {
        var coordTmeno1 = coordinates[indexGPS - 1];
        let lonTmeno1 = coordTmeno1[0];
        let latTmeno1 = coordTmeno1[1];

        var currCoord = coordinates[indexGPS];
        let lonT = currCoord[0];
        let latT = currCoord[1];

        var newLon =
          lonTmeno1 + ((lonT - lonTmeno1) / maxFrames) * currentFrame;
        var newLat =
          latTmeno1 + ((latT - latTmeno1) / maxFrames) * currentFrame;

        // console.log(newLon + "-" + newLat)
        return [newLon, newLat];
      } else {
        return coordinates[indexGPS];
      }
    },


    dynamicSort(property) {
      return function (obj1, obj2) {
        return obj1[property] > obj2[property] ? 1
          : obj1[property] < obj2[property] ? -1 : 0;
      }
    },

    dynamicSortMultiple(self) {
      /*
       * save the arguments object as it will be overwritten
       * note that arguments object is an array-like object
       * consisting of the names of the properties to sort by
       */
      var props = arguments;
      return function (obj1, obj2) {
        var i = 0, result = 0, numberOfProperties = props.length - 1;
        /* try getting a different result from 0 (equal)
         * as long as we have extra properties to compare
         */
        while (result === 0 && i < numberOfProperties) {
          result = props[0].dynamicSort(props[i])(obj1, obj2);
          i++;
        }
        return result;
      }
    },


    isMobileMode: function () {
      let res = this.$vuetify.breakpoint.name === 'xs';
      return res;
    },
      isDesktopMode: function () {
          return !this.isMobileMode();
      },



  }
}